export const ChangePasswordDefaultData = {
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
}
